// extracted by mini-css-extract-plugin
export var worksWrap = "works-module--worksWrap--BUIBB";
export var workWrap = "works-module--workWrap--h8btB";
export var slider = "works-module--slider--oM7Wf";
export var swiperButtonNext = "works-module--swiperButtonNext--JjUqk";
export var swiperButtonPrev = "works-module--swiperButtonPrev--PwRuB";
export var swiperButtonDisabled = "works-module--swiperButtonDisabled--E1PB8";
export var header = "works-module--header--8SzpD";
export var description = "works-module--description--zzIcC";
export var button = "works-module--button---gRC7";